import { MapElementFactory } from "vue2-google-maps";

export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    return window.google.maps.DirectionsRenderer;
  },

  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object, required: true },
    destination: { type: Object, required: true },
    travelMode: { type: String, required: true },
    destinationLabel: { type: String, required: true },  // Added dynamic label for destination
    originLabel: { type: String, required: true } 
  },

  afterCreate(directionsRenderer) {
    const directionsService = new window.google.maps.DirectionsService();
    let initialZoom = null;
    let initialCenter = null;

    const updateDirections = () => {
      const { origin, destination, travelMode } = this;
      const map = directionsRenderer.getMap();

      // if (initialZoom === null) {
        initialZoom = map.getZoom();
        initialCenter = map.getCenter();
      // }

      directionsService.route(
        {
          origin,
          destination,
          travelMode
        },
        (response, status) => {
          if (status === "OK") {
            directionsRenderer.setDirections(response);
            directionsRenderer.setOptions({ suppressMarkers: true });

            // Restore the initial center and zoom level
            map.setCenter(initialCenter);
            map.setZoom(initialZoom);

            // Remove existing markers
            if (this.originMarker) {
              this.originMarker.setMap(null);
            }
            if (this.destinationMarker) {
              this.destinationMarker.setMap(null);
            }

            // Add new markers with updated labels
            const leg = response.routes[0].legs[0];
            this.originMarker = new window.google.maps.Marker({
              position: leg.start_location,
              map: directionsRenderer.getMap(),
              label: this.originLabel || "🚖"
            });
            this.destinationMarker = new window.google.maps.Marker({
              position: leg.end_location,
              map: directionsRenderer.getMap(),
              label: this.destinationLabel || ''
            });
          } else {
            console.error('Directions request failed due to ' + status);
          }
        }
      );
    };

    updateDirections();

    this.$watch(
      () => [this.origin, this.destination, this.travelMode, this.destinationLabel, this.originLabel],
      updateDirections
    );
  }
});
